var map = {
	"./project-1.png": 1356,
	"./project-2.png": 9240,
	"./project-3.png": 3019,
	"./project-4.png": 3918,
	"./project-5.png": 1112,
	"./project-6.png": 9764,
	"./project-7.png": 9009,
	"./project-8.png": 8457,
	"./project-9.png": 613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1324;